import React from 'react';

const styles = {
    color: '#000',
    fontWeight: 'bold',
};

class CaseIdAnchor extends React.Component {
    render() {
        const {text} = this.props;
        return (
            <span
                style={styles}
                aria-label={text}>
                {text}
            </span>
        );
    }
}

export default CaseIdAnchor;
